import template from './media-display.component.html';
import { FeedbackSessionMediaDisplayController } from './media-display.controller';

export const mediaDisplay = {
	template,
	require: {mainController: '^feedbackSession'},
	controller: FeedbackSessionMediaDisplayController
};
